import React from 'react';

const WhatsAppButton = () => {
  const handleClick = (e) => {
    e.preventDefault();
    if (window.gtag) {
      window.gtag('event', 'conversion', {
        send_to: 'AW-18086584660/aTP0CPz2rJscENTCrbBD',
        value: 1.0,
        currency: 'SAR',
      });
    }
    window.open('https://api.whatsapp.com/send?phone=966533993007', '_blank', 'noopener,noreferrer');
  };

  return (
    <button
      data-testid="whatsapp-float-btn"
      onClick={handleClick}
      className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg shadow-black/30 hover:scale-110 transition-transform duration-200 cursor-pointer border-none outline-none"
      aria-label="WhatsApp"
    >
      <svg viewBox="0 0 32 32" className="w-7 h-7 fill-white">
        <path d="M16.004 2.667A13.22 13.22 0 0 0 2.787 15.883a13.12 13.12 0 0 0 1.795 6.612L2.667 29.333l7.063-1.852a13.24 13.24 0 0 0 6.274 1.6h.005A13.22 13.22 0 0 0 29.333 15.9 13.22 13.22 0 0 0 16.004 2.667Zm0 24.19a10.98 10.98 0 0 1-5.6-1.533l-.4-.24-4.18 1.097 1.114-4.078-.263-.418a10.92 10.92 0 0 1-1.68-5.818A10.97 10.97 0 0 1 16.004 4.92 10.97 10.97 0 0 1 27.08 15.9a10.98 10.98 0 0 1-11.076 10.957Zm6.02-8.215c-.33-.165-1.953-.964-2.256-1.074-.303-.11-.524-.165-.744.165s-.854 1.074-1.047 1.294c-.193.22-.386.248-.716.083a9.03 9.03 0 0 1-2.656-1.639 9.97 9.97 0 0 1-1.837-2.288c-.193-.33-.02-.508.145-.672.148-.148.33-.386.496-.578.165-.193.22-.33.33-.55.11-.22.055-.413-.028-.578-.083-.165-.744-1.793-1.02-2.455-.268-.643-.54-.557-.744-.567l-.634-.01a1.21 1.21 0 0 0-.88.414c-.303.33-1.156 1.13-1.156 2.755s1.184 3.196 1.35 3.416c.165.22 2.328 3.554 5.64 4.984.788.34 1.403.543 1.882.695.79.252 1.51.216 2.078.131.634-.095 1.953-.798 2.228-1.569.276-.77.276-1.43.193-1.569-.083-.138-.303-.22-.634-.386Z" />
      </svg>
    </button>
  );
};

export default WhatsAppButton;
